var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfterEprQa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 130,
    viewBox: "0 0 71 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M68.5072 129.141C36.3553 130.096 15.4965 130.581 6.92611 120.556C-4.25653 101.48 3.19062 95.1807 1.69687 57.345C0.370298 21.7933 4.00521 1.46655 23.2501 0.102539C25.243 0.110718 44.2541 0.188416 70.1937 0.294495",
    fill: "#00376F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.8748 129.13C67.1212 129.183 64.6585 129.255 61.7068 129.331C59.8143 129.38 57.343 129.443 55.0562 129.488C50.0377 129.587 45.7317 129.672 40.5264 129.567C38.1807 129.519 34.8729 129.417 30.8838 129.174C31.4993 86.1592 32.1147 43.144 32.7302 0.128906C45.3405 0.180481 57.9508 0.232056 70.561 0.28363C69.9989 43.2325 69.4369 86.1815 68.8748 129.13Z",
    fill: "url(#paint0_linear_1104_3450)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1104_3450",
    x1: 31.3551,
    y1: 64.758,
    x2: 70.0873,
    y2: 65.0414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterEprQa);
export default __webpack_public_path__ + "static/media/after-EPR-QA.05225909f52d0a7c6ce01f9f5c1d40cd.svg";
export { ForwardRef as ReactComponent };